module.exports = __webpack_public_path__ + "media/images/android-icon-192x192-f675ef93ef88e634c2c4dde2e329152d.png";